export enum Status {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED"
}